import { createContext, useState } from "react";
import { ContextProviderPropsType, AppContextType } from "../types/context.type";

export const AppContext = createContext({} as AppContextType);

export const AppContextProvider: React.FC<ContextProviderPropsType> = ({ children }) => {
    const [isMobileSideNavigationOpen, setIsMobileSideNavigationOpen] = useState(false);
    const [isSideNavigationClosing, setIsSideNavigationClosing] = useState(false);
    const [activeNavItem, setActiveNavItem] = useState<string | undefined>(undefined);

    return (
        <AppContext.Provider
            value={{
                isMobileSideNavigationOpen,
                setIsMobileSideNavigationOpen,
                isSideNavigationClosing,
                setIsSideNavigationClosing,
                activeNavItem,
                setActiveNavItem
            }}
        >
            {children}
        </AppContext.Provider>
    )
}